import React, { forwardRef } from 'react'
import MatrixMessageContextMenu from 'matrix-react-sdk/lib/components/views/context_menus/MessageContextMenu'
import { deliveryStateOptions } from '../../utils/delivery'

const MessageContextMenu = forwardRef((props, ref) => {
  return (
    <MatrixMessageContextMenu
      {...props}
      ref={ref}
      deliveryStateOptions={deliveryStateOptions}
    />
  )
})

export default MessageContextMenu
